export default function getIdFromShopifyGraphIdShopifyUtil (gid) {
  const gidArr = gid.split('/')
  const lastElement = gidArr[gidArr.length - 1]
  const indexOfQuery = lastElement.indexOf('?')
  return Number(indexOfQuery !== -1 ? lastElement.slice(0, indexOfQuery) : lastElement)
}
